import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../../services/firebase';
import {
  CAPTURES_COLLECTION,
  CAPTURE_EXTRACTION_VERSION,
  buildCapturePayload,
} from './captureModel';

export const createCapture = async ({
  childId = '',
  userId = '',
  sourceType = 'unknown',
  sourceText = '',
  originalText = '',
  inputContext = {},
  metadata = {},
  status,
} = {}, deps = {}) => {
  const firestoreDb = deps.db || db;
  const collectionFn = deps.collection || collection;
  const add = deps.addDoc || addDoc;
  const timestamp = deps.serverTimestamp || serverTimestamp;
  const payload = buildCapturePayload({
    childId,
    userId,
    sourceType,
    sourceText,
    originalText,
    inputContext,
    metadata,
    status,
    now: timestamp(),
  });
  const docRef = await add(collectionFn(firestoreDb, CAPTURES_COLLECTION), payload);

  return {
    captureId: docRef.id,
    extractionVersion: payload.extractionVersion || CAPTURE_EXTRACTION_VERSION,
    payload,
  };
};
